import config from 'config'
import {BRANDS, BRAND_PARTNERS, LOGIN_CASES} from 'const'
import {getDefaultConfig, getFooterLogosByBrandList, getFavicon, getHeaderLogo} from '../commonHelper'
import {isProd} from 'utils/envUtils'
import {FOOTER_LOGO_TYPES} from 'const/logos'

const BRAND_URL = 'https://www.beobachter.ch'
const authorizeRedirectURL = `https://${isProd() ? 'www.' : 'stage.'}beobachter.ch/authorize`

const NORMAL_FONT = "'Spezia Regular', Helvetica, Arial, sans-serif"
const BOLD_FONT = "'Spezia Bold', Helvetica, Arial, sans-serif"

const otherBrandsLogos = getFooterLogosByBrandList([
  BRANDS.beobachter,
  BRANDS.wirtschaftsmedien,
  BRANDS.blick,
  BRAND_PARTNERS.bilanz,
])

const COLORS = {
  body: '#000000',
  ultraLight4: '#F7F7F7',
  normal: '#AB0000',
  hover: '#6C0000',
  beo1Light: '#D8D8D8',
  beo2Medium: '#3E3E3E',
  beoTextLight: '#888888',
  beo3Dark: '#1F1F1F',
  info2: '#029DD2',
  info: '#15528E',
  error: '#DF0000',
  success: '#009164',
  warning: '#009164',
  greyChateau: '#9BA5AD',
  fiord2: '#3C5162',
}

export default {
  brand: {
    name: BRANDS.beobachter,
    url: BRAND_URL,
    fontColor: '#fff',
    favicon: getFavicon(BRANDS.beobachter),
    authorizeRedirectURL,
  },
  config: {
    ...getDefaultConfig(),
    useCircularSocialLogin: true,
    marketingOnePager: ({loginCase}) => loginCase === LOGIN_CASES.EMAIL_ONLY,
    newsletterOnePager: true,
    admeiraOptInOnePager: true,
    marketingConsent: true,
    onePager: ({loginCase}) => LOGIN_CASES.EMAIL_ONLY === loginCase,
    showProgressBar: ({loginCase}) => [LOGIN_CASES.BEO.BEOPLUS].includes(loginCase),
    newsletterConsent: true,
    showRingierBanner: false,
  },
  fontConfig: {
    custom: {
      urls: [`${config.url}/fonts/beo/index.css`],
    },
  },
  otherBrandsLogos,
  font: {
    family: NORMAL_FONT,
    fontWeight: '400',
    boldFamily: BOLD_FONT,
    boldFontWeight: '700',
    size: '16px',
    height: '24px',
    mobile: {
      size: '16px',
      height: '24px',
    },
    portrait: {
      size: '16px',
      height: '24px',
    },
    color: {
      dark: COLORS.body,
      light: '#FFFFFF',
    },
  },
  secondaryFont: {
    height: '18px',
    mobile: {
      size: '14px',
      height: '18px',
    },
    portrait: {
      size: '16px',
      height: '20px',
      backlink: '14px',
    },
  },
  title: {
    family: BOLD_FONT,
    weight: '700',
    size: '28px',
    height: '32px',
    mobile: {
      size: '26px',
      height: '35px',
    },
    portrait: {
      size: '34px',
      height: '46px',
    },
  },
  ringierBanner: {
    border: `1px solid ${COLORS.beo1Light}`,
    borderRadius: '4px',
    fontSize: '16px',
    linkFontSize: '14px',
    padding: '20px',
    iconHeight: '24px',
    benefitsIcon: `${config.url}/assets/brands/beobachter/icon-check-banner.svg`,
    backgroundColor: '#FFFFFF',
    linkColor: COLORS.body,
    linkHoverColor: COLORS.normal,
    benefitMessageColor: COLORS.body,
    titleFontFamily: BOLD_FONT,
    titleFontWeight: 700,
    iconWidth: '24px',
    lineHeight: '24px',
    landscape: {
      fontSize: '16px',
    },
    onelogLogo: {
      src: `${config.url}/assets/logo-onelog-black.svg`,
      height: '28px',
      width: '132px',
      margin: '0 0 8px 0',
    },
    onelogTitle: {
      fontSize: '14px',
      fontWeight: 700,
      lineHeight: '20px',
      color: COLORS.body,
      fontFamily: BOLD_FONT,
      margin: '0 0 20px 0',
    },
    onelogSection: {
      width: '290px',
      padding: '40px 0 0 0',
      borderTop: `1px solid ${COLORS.beo1Light}`,
    },
  },
  note: {
    family: NORMAL_FONT,
    fontSize: '16px',
    fontWeight: '700',
    lightFontWeight: '400',
    termsTitle: {
      fontWeight: '400',
      fontFamily: NORMAL_FONT,
    },
  },
  notification: {
    family: '',
    success: COLORS.success,
    error: COLORS.error,
    warning: COLORS.warning,
    pageError: COLORS.error,
    info: COLORS.info,
    icon: {
      width: '24px',
      height: '24px',
      mobile: {
        width: '32px',
        height: '32px',
      },
    },
    pageMessage: {
      size: '16px',
      height: '24px',
      sizeMobile: '14px',
      heightMobile: '20px',
    },
  },
  background: {
    light: '#FFFFFF',
    dark: '#C10712',
  },
  logisterSection: {
    registerSize: '16px',
    registerMarginTop: '20px',
    registerWeight: 400,
    subheaderPadding: '16px 20px',
    subheaderFontSize: '14px',
    subheaderLineHeight: '20px',
    subheaderTitleColor: COLORS.body,
    subheaderTitleMargin: '0 0 4px 0',
    subheaderLinkColor: COLORS.body,
    subheaderLinkHoverColor: COLORS.normal,
    noteColor: COLORS.beoTextLight,
    noteFontSize: {
      default: '16px',
      portrait: '16px',
    },
    title: {
      textChangeBreakpoint: 'landscape',
      fontSize: {
        smallMobile: '24px',
        mobile: '28px',
        portrait: '28px',
        landscape: '32px',
        desktop: '34px',
      },
      lineHeight: {
        smallMobile: '32px',
        mobile: '32px',
        portrait: '36px',
        landscape: '40px',
        desktop: '48px',
      },
    },
    subtitle: {
      color: COLORS.body,
      fontSize: {
        default: '16px',
        portrait: '16px',
      },
      lineHeight: '20px',
      margin: '0 0 14px',
      link: {
        color: COLORS.body,
        hoverColor: COLORS.normal,
      },
    },
    hasOnelogNote: true,
  },
  form: {
    border: '',
    background: '',
    fieldBackground: '',
    padding: '0 0 24px 0',
    sectionViewBackground: '#f8f8f8',
    marginBottom: '0',
    loginSubmitMarginTop: 16,
    note: {
      fontSize: '16px',
    },
  },
  field: {
    label: {
      family: NORMAL_FONT,
      fontWeight: '400',
      color: COLORS.body,
      disabledColor: COLORS.beoTextLight,
      fontSize: '14px',
      fontHeight: '18px',
      bottomMargin: '8px',
    },
    error: {
      background: 'inherit',
      fontColor: COLORS.error,
      size: '14px',
      height: '18px',
      padding: '0',
      margin: '8px 0 0',
    },
    optional: {
      color: COLORS.beo2Medium,
      family: NORMAL_FONT,
    },
    edging: {
      backgroundColor: '#FFFFFF',
    },
  },
  edging: {
    borderRadius: '4px',
    border: `1px solid ${COLORS.beo1Light}`,
  },
  logisterForm: {
    border: '',
    background: '',
    padding: '28px 0 0 0',
    submitButton: 'primary',
    submitButtonMargin: '36px 0 0 0',
    forgetLinkFloat: 'right',
  },
  loginForm: {
    submitButtonMargin: 36,
    title: {
      margin: '0 0 48px',
    },
    forgetLink: {
      wrapper: {
        defaultMarginBottom: '20px',
        errorMarginBottom: '22px',
      },
      link: {
        fontSize: '14px',
        marginTop: '6px',
        color: COLORS.body,
      },
    },
  },
  registerPage: {
    backLinkMargin: {
      default: '0 0 24px',
      portrait: '0 0 24px',
    },
    titleMargin: {
      default: '0 0 24px',
      portrait: '0 0 24px',
    },
    submitButtonMarginTop: 36,
    subtitle: {
      fontFamily: BOLD_FONT,
      fontSize: '18px',
      lineHeight: '27px',
      margin: '0 0 48px',
      fontWeight: '700',
      color: COLORS.body,
    },
  },
  resetPasswordPage: {
    subtitle: {
      fontSize: '16px',
      lineHeight: '23px',
      margin: '0 0 48px 0',
    },
  },
  emailVerifyPage: {
    noteMarginTop: '36px',
    linkMarginBottom: '10px',
    subtitleFontSize: '18px',
    note: {
      fontFamily: BOLD_FONT,
    },
    link: {
      color: COLORS.body,
    },
    subtitle: {
      fontFamily: BOLD_FONT,
      color: COLORS.body,
    },
  },
  emailVerifiedPage: {
    subtitle: {
      fontFamily: BOLD_FONT,
      fontSize: '18px',
    },
  },
  buttons: {
    height: '48px',
    primary: {
      border: `1px solid ${COLORS.normal}`,
      color: '#FFFFFF',
      background: COLORS.normal,
      hoverBorder: `1px solid ${COLORS.hover}`,
      hoverBackground: COLORS.hover,
      activeBorder: `1px solid ${COLORS.hover}`,
      activeBackground: COLORS.normal,
      focusBorder: `1px solid #ffffff`,
      focusBoxShadow: '0 0 0 2px rgba(171, 0, 0, 0.6)',
      textStyles: {
        family: BOLD_FONT,
        size: '16px',
        weight: 700,
      },
    },
    secondary: {
      border: `1px solid ${COLORS.normal}`,
      color: COLORS.normal,
      background: '#FFFFFF',
      hoverBorder: `1px solid ${COLORS.normal}`,
      hoverColor: COLORS.hover,
      hoverBackground: '#FFFFFF',
      activeBorder: `1px solid ${COLORS.hover}`,
      activeColor: COLORS.normal,
      activeBackground: '#FFFFFF',
      focusBorder: `1px solid #ffffff`,
      focusBoxShadow: '0 0 0 2px rgba(171, 0, 0, 0.6)',
      dotsColor: COLORS.normal,
      textStyles: {
        family: BOLD_FONT,
        size: '16px',
        weight: 700,
      },
    },
    disabled: {
      border: `1px solid ${COLORS.beo1Light}`,
      color: COLORS.beoTextLight,
      background: COLORS.beo1Light,
      hoverBorder: null,
      hoverBackground: COLORS.beo1Light,
      activeBorder: null,
      activeBackground: COLORS.beo1Light,
      textStyles: {
        family: BOLD_FONT,
        size: '16px',
        weight: 700,
      },
    },
    swiss: {
      full: true,
      border: '1px solid #C5C5C5',
      color: '#444',
      background: '#ffffff',
      hoverBackground: '#ffffff',
      activeBackground: '#ffffff',
      hoverColor: '#444',
      hoverBorder: '1px solid #777',
      focusBorder: '1px solid #889',
      activeColor: '#444',
      activeBorder: '1px solid #888',
      icon: 'swiss_id_rot.png',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
    },
    apple: {
      full: true,
      border: '1px solid #C5C5C5',
      color: '#444',
      background: '#FFFFFF',
      hoverColor: '#444',
      hoverBorder: '1px solid #777',
      focusBorder: '1px solid #889',
      activeColor: '#444',
      activeBorder: '1px solid #888',
      icon: 'logo-apple-black.svg',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
    },
    facebook: {
      full: true,
      border: '1px solid #C5C5C5',
      color: '#444',
      background: '#FFFFFF',
      hoverColor: '#444',
      hoverBorder: '1px solid #777',
      focusBorder: '1px solid #889',
      activeColor: '#444',
      activeBorder: '1px solid #888',
      icon: 'icon-facebook-24x24.svg',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
    },
    google: {
      full: true,
      border: '1px solid #C5C5C5',
      color: '#444',
      background: '#FFFFFF',
      hoverColor: '#444',
      hoverBorder: '1px solid #777',
      focusBorder: '1px solid #889',
      activeColor: '#444',
      activeBorder: '1px solid #888',
      icon: 'icon-google-24x24.svg',
      iconStyles: {
        padding: '12px',
        marginLeft: '0',
      },
    },
    touchId: {
      border: `1px solid ${COLORS.normal}`,
      color: '#FFFFFF',
      background: COLORS.normal,
      hoverBorder: `1px solid ${COLORS.hover}`,
      hoverBackground: COLORS.hover,
      focusBorder: `1px solid #ffffff`,
      focusBoxShadow: '0 0 0 2px rgba(171, 0, 0, 0.6)',
      activeBorder: `1px solid ${COLORS.normal}`,
      activeBackground: COLORS.normal,
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
    },
    faceId: {
      border: `1px solid ${COLORS.normal}`,
      color: '#FFFFFF',
      background: COLORS.normal,
      hoverBorder: `1px solid ${COLORS.hover}`,
      hoverBackground: COLORS.hover,
      focusBorder: `1px solid #ffffff`,
      focusBoxShadow: '0 0 0 2px rgba(171, 0, 0, 0.6)',
      activeBorder: `1px solid ${COLORS.normal}`,
      activeBackground: COLORS.normal,
      icon: 'icon-faceid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
    },
    anyId: {
      border: `1px solid ${COLORS.normal}`,
      color: '#FFFFFF',
      background: COLORS.normal,
      hoverBorder: `1px solid ${COLORS.hover}`,
      hoverBackground: COLORS.hover,
      focusBorder: `1px solid #ffffff`,
      focusBoxShadow: '0 0 0 2px rgba(171, 0, 0, 0.6)',
      activeBorder: `1px solid ${COLORS.normal}`,
      activeBackground: COLORS.normal,
    },
    icon: {
      height: '24px',
      width: '24px',
    },
    text: {
      family: NORMAL_FONT,
      weight: '500',
      color: '#000000',
      size: '16px',
    },
    border: {
      size: '1px',
      radius: '24px',
    },
  },
  link: {
    default: '#000000',
    hoverColor: COLORS.normal,
    secondary: '#000000',
    secondaryHover: COLORS.normal,
    isAgreementsLink: false,
    textDecorationHover: 'underline',
  },
  input: {
    background: '#ffffff',
    errorBackground: '#ffffff',
    borderRadius: '4px',
    border: `1px solid ${COLORS.beo2Medium}`,
    focusBorder: `1px solid ${COLORS.info2}`,
    errorBorder: `1px solid ${COLORS.error}`,
    hoverBorder: `1px solid ${COLORS.beo2Medium}`,
    height: '48px',
    email: {
      backgroundColor: COLORS.ultraLight4,
      border: `1px solid ${COLORS.ultraLight4}`,
      button: {
        height: '32px',
        right: '12px',
        fontFamily: BOLD_FONT,
        backgroundColor: '#FFFFFF',
        color: COLORS.normal,
        fontSize: '14px',
        textDecoration: 'none',
        border: `1px solid ${COLORS.normal}`,
        borderRight: `1px solid ${COLORS.normal}`,
        hoverColor: COLORS.hover,
        hoverBorder: `1px solid ${COLORS.hover}`,
        hoverBorderRight: `1px solid ${COLORS.hover}`,
      },
    },
    password: {
      color: COLORS.body,
      hoverColor: COLORS.normal,
      size: '14px',
      height: '22px',
      top: '14px',
    },
    placeholder: {
      color: COLORS.beoTextLight,
      fontSize: '16px',
      lineHeight: '18px',
    },
  },
  inputNote: {
    color: COLORS.body,
    size: '14px',
    height: '20px',
    marginTop: '8px',
  },
  separator: {
    background: COLORS.beo1Light,
    color: COLORS.body,
    height: '1px',
    fontSize: '16px',
    lineHeight: '25px',
    lineMarginTop: '0',
    margin: '48px 0 36px 0',
    portraitMargin: '48px 0 36px 0',
    landscapeMargin: '48px 0 36px 0',
  },
  tab: {
    fontSize: '18px',
    desktop: {
      focusBorder: 'solid 4px #000000',
      bottomMargin: '-4px',
      height: '80px',
    },
    mobile: {
      icon: {
        border: 'solid 2px #ACACAC',
        width: '14px',
        height: '14px',
        color: '#000000',
      },
    },
  },
  shell: {
    header: {
      color: '#000000',
      backgroundColor: '#FFFFFF',
      border: {
        width: '0 0 1px 0',
        color: COLORS.beo1Light,
        style: 'solid',
      },
      poweredLogo: {
        src: 'logo-onelog-poweredby-grey.png',
      },
      height: {
        default: '80px',
        onScroll: '56px',
        withEmail: '102px',
      },
      logo: {
        height: {
          default: '40px',
          small: '32px',
          onScroll: '32px',
        },
        src: {
          default: getHeaderLogo(BRANDS.beobachter),
        },
      },
      logoMarginRight: {
        default: '15px',
        portrait: '32px',
      },
      languageSwitcher: {
        color: COLORS.greyChateau,
        activeColor: COLORS.fiord2,
        backgroundColor: '#FFFFFF',
        menu: {
          fontSize: '14px',
          lineHeight: '22px',
          color: COLORS.fiord2,
          hoverColor: '#FFFFFF',
          hoverBackgroundColor: COLORS.fiord2,
        },
      },
      menu: {
        default: {
          color: COLORS.greyChateau,
          fontSize: '20px',
        },
        active: {
          color: COLORS.greyChateau,
          hoverColor: '#ffffff',
          selectedColor: '#ffffff',
          backgroundColor: '#ffffff',
          hoverBackgroundColor: COLORS.fiord2,
          selectedBackgroundColor: COLORS.fiord2,
          separatorColor: '#2C3B47',
        },
      },
    },
    footer: {
      tenants: {
        logoColor: FOOTER_LOGO_TYPES.white,
        color: '#FFFFFF',
        hoverColor: '#FFFFFF',
        backgroundColor: COLORS.beo2Medium,
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: COLORS.beo1Light,
        link: {
          textDecoration: 'none',
        },
      },
      copyright: {
        color: '#FFFFFF',
        hoverColor: '#FFFFFF',
        backgroundColor: COLORS.beo3Dark,
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: COLORS.beo1Light,
      },
    },
  },
  checkbox: {
    icon: {
      height: '28px',
      width: '28px',
      top: '-2px',
      right: '6px',
      image: 'brands/beobachter/form/checkbox.svg',
      checkedImage: 'brands/beobachter/form/checkbox-checked.svg',
      hoverImage: 'brands/beobachter/form/checkbox-hover.svg',
      errorImage: 'brands/beobachter/form/checkbox-error.svg',
      disabledImage: 'brands/beobachter/form/checkbox-disabled.svg',
    },
    errorMargin: '',
    padding: '16px 20px',
    labelFontHeight: '24px',
    errorPadding: '4px 20px 0',
    fontSize: '14px',
    newsletterGroup: {
      fontFamily: BOLD_FONT,
      fontSize: '14px',
    },
    marketing: {
      hideLabel: true,
      border: '1px solid #D8D8D8',
      borderRadius: '4px',
    },
    group: {
      label: {
        marginBottom: '8px',
        padding: '0',
        backgroundColor: '',
      },
      fontWeight: '400',
      fontSize: '14px',
      marginBottom: '20px',
      padding: '0 20px',
      backgroundColor: '#f6f6f6',
      note: {
        fontWeight: '300',
        fontSize: '14px',
        marginLeft: '36px',
      },
    },
  },
  select: {
    icon: {
      width: '16px',
      height: '16px',
      image: 'from-arrow-down.svg',
      focusImage: 'from-arrow-down.svg',
      alt_image: 'from-arrow-down.svg',
    },
    menu: {
      border: '1px solid #bdb9b9',
      option: {
        focusBorder: '1px solid #f1f1f1',
        focusBackground: '#f9f9fb',
      },
    },
  },
  radio: {
    fontSize: '14px',
    icon: {
      width: '20px',
      height: '20px',
      image: 'brands/beobachter/form/radio.svg',
      checkedImage: 'brands/beobachter/form/radio-active.svg',
      hoverImage: 'brands/beobachter/form/radio-hover.svg',
      errorImage: 'brands/beobachter/form/radio-error.svg',
      disabledImage: 'brands/beobachter/form/radio-disabled.svg',
    },
    errorMargin: '8px 0 0',
    labelFontHeight: '28px',
    labelMarginBottom: '8px',
  },
  errorPage: {
    font: {
      height: '18px',
      portrait: {
        height: '30px',
      },
    },
  },
  consent: {
    checkbox: {
      marginBottom: '20px',
      paddingBottom: '',
    },
  },
  mobileNumber: {
    label: {
      marginBottom: '20px',
    },
    subtitle: {
      marginTop: '8px',
    },
    select: {
      padding: '8px 0px 8px 12px',
    },
    selectIcon: {
      padding: '0px 12px',
    },
    input: {
      padding: '8px 12px',
    },
    code: {
      letterSpacing: '12px',
      paddingLeft: {
        normal: 'calc(50% - 50px)',
        error: 'calc(50% - 51px)',
      },
      underline: {
        left: 'calc(50% - 20px)',
        top: 'calc(50% - 7px)',
      },
    },
    verifiedLabel: {
      color: '#292E32',
    },
    container: {
      marginBottom: '15px',
    },
  },
  address: {
    padding: '20px',
    inputBackgroundColor: '#FFFFFF',
    formFieldMarginBottom: '',
    checkboxPadding: '',
    link: {
      fontSize: '12px',
      lineHeight: '16px',
    },
  },
  mfa: {
    inputBackgroundColor: '#FFFFFF',
    link: {
      hoverColor: COLORS.normal,
    },
  },
  languageSwitcher: {
    profileMenuIcon: 'OL-icon-arrow-down-white.svg',
    profileMenuColor: COLORS.greyChateau,
  },
  social: {
    title: {
      fontWeight: '400',
      fontFamily: NORMAL_FONT,
      marginBottom: '24px',
    },
  },
  progressBar: {
    color: COLORS.beoTextLight,
    activeColor: COLORS.body,
    item: {
      default: {
        color: COLORS.beoTextLight,
        border: `2px solid ${COLORS.beoTextLight}`,
      },
      active: {
        color: COLORS.error,
        border: `2px solid ${COLORS.error}`,
      },
    },
  },
}
